/**
 * Training Course interfaces for MCS Report Catalog Training Tab
 */

export interface ITrainingLesson {
  title: string;
  durationMinutes: number;
}

export interface ITrainingCourse {
  id: number;
  courseNumber: number;
  isRequired: boolean;
  title: string;
  durationMinutes: number;
  description?: string;
  dueDate?: string;
  smeName?: string;
  smeEmail?: string;
  releaseDate?: string;
  portal?: string;
  link?: string;
  lessonsJson?: string;
  learningPath?: string;
  status?: string;
  isActive: boolean;
  sortOrder: number;
}

export interface ITrainingCourseWithLessons extends ITrainingCourse {
  lessons: ITrainingLesson[];
}

/**
 * Parse lessons JSON from the API response
 */
export function parseTrainingLessons(lessonsJson?: string): ITrainingLesson[] {
  if (!lessonsJson) return [];
  try {
    return JSON.parse(lessonsJson);
  } catch {
    return [];
  }
}

/**
 * Format duration in minutes to a readable string
 */
export function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
}

/**
 * Format date to a readable string
 */
export function formatDate(dateString?: string): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

/**
 * Calculate time ago string from release date
 */
export function getTimeAgo(dateString?: string): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "today";
  if (diffDays === 1) return "1d ago";
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}mo ago`;
  return `${Math.floor(diffDays / 365)}y ago`;
}
